import {ProcessExecutionType, ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {
  getPowAgnosticProcedureFromFlowchartVersion,
  getPowAgnosticTemplateFlowchartVersionFromProcedureRun,
} from 'procedures/utils/powAgnosticFlowchartHelpers';
import {processExecutionTypeDisplayName} from 'processes/ProcessConstants';
import {NO_ACCESS_TEXT} from 'processes/ProcessConstants';
import {ChipPopoverInfoField} from 'ui-library/chips/ChipPopoverContent';

import {InaccessibleInfoGraphQL} from '../../../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';

interface ProcedureChipLabels {
  RECIPE_CONDITION_REPLICATE_RUN: string;
  RECIPE_UNIT_OPERATION: string;
  RECIPE_TEMPLATE: string;
  ASSAY_TEMPLATE: string;
  ASSAY_CONDITION_REPLICATE_RUN: string;
  ASSAY_UNIT_OPERATION: string;
  WORKSHEET: string;
}

export function getProcedureChipPopoverFields(): ProcedureChipLabels {
  return {
    RECIPE_CONDITION_REPLICATE_RUN: processExecutionTypeDisplayName(
      ProcessClientOrigin.RECIPES,
      ProcessExecutionType.PROCEDURE
    ),
    RECIPE_UNIT_OPERATION: processExecutionTypeDisplayName(
      ProcessClientOrigin.RECIPES,
      ProcessExecutionType.PROCEDURE_METHOD
    ),
    ASSAY_CONDITION_REPLICATE_RUN: processExecutionTypeDisplayName(
      ProcessClientOrigin.ASSAYS,
      ProcessExecutionType.PROCEDURE
    ),
    ASSAY_UNIT_OPERATION: processExecutionTypeDisplayName(
      ProcessClientOrigin.ASSAYS,
      ProcessExecutionType.PROCEDURE_METHOD
    ),
    RECIPE_TEMPLATE: 'Recipe',
    ASSAY_TEMPLATE: 'Assay',
    WORKSHEET: 'Worksheet',
  };
}

// Exported for testing
export interface ProcedureRunGql {
  __typename: 'ProcedureRunNode';
  templateProcedureFlowchartVersion:
    | {
        __typename: 'ProcedureFlowchartVersionNode';
        procedureFlowchart: {
          __typename: 'ProcedureFlowchartNode';
          parent: {
            __typename: 'ProcedureNode';
            name: string;
          } | null;
        };
      }
    | InaccessibleInfoGraphQL;
  procedureFlowchartConfigVersionProxy?:
    | {
        __typename: 'ProcedureFlowchartConfigVersionProxyNode';
        procedure: {
          __typename: 'ProcedureNode';
          name: string;
        };
      }
    | InaccessibleInfoGraphQL
    | null;
}

export function getProcedureTemplateField(
  procedureRun: ProcedureRunGql | null,
  clientOrigin: ProcessClientOrigin
): ChipPopoverInfoField {
  let value = null;
  if (procedureRun == null) {
    value = '';
  } else {
    const flowchartVersion = getPowAgnosticTemplateFlowchartVersionFromProcedureRun(procedureRun);
    if (isInaccessible(flowchartVersion)) {
      value = NO_ACCESS_TEXT;
    } else {
      value = getPowAgnosticProcedureFromFlowchartVersion(flowchartVersion).name;
    }
  }
  const procedureChipPopoverFields = getProcedureChipPopoverFields();
  return {
    label:
      clientOrigin === ProcessClientOrigin.RECIPES
        ? procedureChipPopoverFields.RECIPE_TEMPLATE
        : procedureChipPopoverFields.ASSAY_TEMPLATE,
    value,
  };
}
